import {createAsyncThunk} from "@reduxjs/toolkit";
import axios, {AxiosError} from "axios";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {getTestIdResponse} from "features/model/types/test/getTestIdShema";
import {clearTestState, getModalTests} from "features/model/slice/test/get-test/getTestSlice";
import {setBackData} from "features/model/slice/create-test/create-test-form/createTestForm";
import {resetCorrectTestCount} from "features/model/slice/test/correct-test/correctTestSlice";
import {setNotFoundError} from "features/model/slice/error/errorSlice";


export const fetchTest = createAsyncThunk(
    'test/getTest',
    async (testId: string | undefined, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error('No token found in localStorage.');
            }
            const {token} = JSON.parse(authToken);

            const response = await axios.get<getTestIdResponse>(`/api/tests/${testId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data.success) {
                thunkAPI.dispatch(getModalTests(response.data.data.model));
                thunkAPI.dispatch(setBackData(response.data.data.model));
                console.log(response.data.data.model,'response.data.data.model')
            } else {
                throw new Error('Ошибка сохранения урока.');
            }
            return response.data;
        } catch (error) {
            thunkAPI.dispatch(setNotFoundError((error as AxiosError).response!.status));
        }
    }
);
